import { render, staticRenderFns } from "./FormGlb.vue?vue&type=template&id=9548366e&"
import script from "./FormGlb.vue?vue&type=script&lang=js&"
export * from "./FormGlb.vue?vue&type=script&lang=js&"
import style0 from "./FormGlb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports